
import ClipboardText from "../../../assets/outline/ClipboardText.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ClipboardTextIcon({ className, dataTestid = "ClipboardTextIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ClipboardText data-testid={dataTestid} className={classes} {...rest} />
  );
}
